import ResourceTyped from './ResourceTyped';

export type ContractAcceptedType = {
	id: number;
	contractId: number;
	customerId: number;
	userId: number;
	masterUserId: number;
	body: string;
	version: number;
	userIp: string;
	userEmail: string;
	userName: string;
	date: string;
};

export type ContractAcceptedSaveType = {
	contractId: number;
};

class ContractAccepted extends ResourceTyped<ContractAcceptedType, ContractAcceptedType, ContractAcceptedSaveType> {
	constructor() {
		super('contractAccepted', undefined, { notificationTitle: 'app.terms' });
	}
}

const resource = new ContractAccepted();

export default resource;
